export default {
    "ids": {
        "flesh": {
            "bones+flesh+skin": "440837375",
            "bones+flesh": "440839221",
            "bones+skin": "440840715",
            "flesh+skin": "440843205",
            "bones": "440726052",
            "flesh": "440728255",
            "skin": "440730518"
        },
        "skin": {
            "bones+flesh+skin": "440845341",
            "bones+flesh": "440845929",
            "bones+skin": "440846467",
            "flesh+skin": "440847046",
            "bones": "440732809",
            "flesh": "440734387",
            "skin": "440736286"
        },
        "bones": {
            "bones+flesh+skin": "440832109",
            "bones+flesh": "440959420",
            "bones+skin": "440833934",
            "flesh+skin": "440835416",
            "bones": "440714825",
            "flesh": "440717776",
            "skin": "440720626"
        }
    },
    "titles": {
        "flesh": {
            "bones+flesh+skin": "this flesh; these bones, this flesh, this skin",
            "bones+flesh": "this flesh; these bones, this flesh",
            "bones+skin": "this flesh; these bones, this skin",
            "flesh+skin": "this flesh; this flesh, this skin",
            "bones": "this flesh; these bones",
            "flesh": "this flesh; this flesh",
            "skin": "this flesh; this skin"
        },
        "skin": {
            "bones+flesh+skin": "this skin; these bones, this flesh, this skin",
            "bones+flesh": "this skin; these bones, this flesh",
            "bones+skin": "this skin; these bones, this skin",
            "flesh+skin": "this skin; this flesh, this skin",
            "bones": "this skin; these bones",
            "flesh": "this skin; this flesh",
            "skin": "this skin; this skin"
        },
        "bones": {
            "bones+flesh+skin": "these bones; these bones, this flesh, this skin",
            "bones+flesh": "these bones; these bones, this flesh",
            "bones+skin": "these bones; these bones, this skin",
            "flesh+skin": "these bones; this flesh, this skin",
            "bones": "these bones; these bones",
            "flesh": "these bones; this flesh",
            "skin": "these bones; this skin"
        }
    },
}
